export default {
  dataModel: {
    types: ['pair:Finality'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};
